// 本地css/js
import './assets/css/base.css'
import './assets/js/jquery-2.1.0.js'
import './assets/js/md5.js'
import './assets/js/common.js'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// element ui
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
// vant ui
import Vant from 'vant';
import 'vant/lib/vant-css/index.css';
Vue.use(Vant);
// axios
import axios from 'axios'
// axios 默认请求地址前缀
//axios.defaults.baseURL = 'http://api-t.auth.lvjinhui.cn/'; //测试
axios.defaults.baseURL = 'https://api.auth.bjzjtp.com/'; //正式
//axios.defaults.baseURL = '/';
Vue.prototype.$axios = axios
// 全局变量
Vue.prototype.appsecret = "03hkw6fvgjdc18ap2iyxre4nubt7osmq";
Vue.config.productionTip = false
Vue.prototype.tj = function(appkey, path) {
		//				console.log(this.appkey)
		//		let self = this;
		this.$axios.post("http://api.auth.bjzjtp.com/tally/index", {
			//		this.$axios.post("http://api-t.auth.lvjinhui.cn/index/tally/index", {
			appkey: appkey,
			path: path
		}).then(function(res) {
			//			console.log(11111)
		}).catch(function(err) {
			console.log(err);
		});
	},
	new Vue({
		router,
		store,
		render: h => h(App)
	}).$mount('#app')